module.exports = __webpack_public_path__ + "static/media/main_btn_QR.8dd10fd6.png";